module.exports = __webpack_public_path__ + "files/e7bdf9e4d1a5ac340876242f425e8a6c.png";